import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'react-bootstrap'

import FilterSearch from 'pages/parts/FilterSearch'
import PeriodPicker from 'pages/parts/PeriodPicker'
import FilterPagination from 'pages/parts/FilterPagination'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'

import { returnSign, formatMoney, formatDate } from "helpers/helpers"
import { GET, httpOk } from 'helpers/api'

// История SMS точки: что ушло, кому, за какое событие и почём.
// Отказы показываем наравне с отправленными: «часть гостей не получает SMS»
// должно иметь видимую причину, а не оставаться загадкой.
function Index() {
	const { t } = useTranslation()

	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const initialFilterData = { start_date: null, end_date: null, status: '', search: '' }
	const initialPagination = { url: '/sms-messages', response: null }
	const {
		filterData,
		appliedFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		patchFilterData,
		applySearch,
		applyFilters,
		paginate,
		resetFilters,
	} = useFilterSearchPagination({ initialFilterData, initialPagination })
	const [data, setData] = useState({})

	const statuses = {
		'0': { 'label': t('sms_status_pending'), 'class': 'bg-secondary' },
		'1': { 'label': t('sms_status_sent'), 'class': 'bg-success' },
		'-1': { 'label': t('sms_status_failed'), 'class': 'bg-danger' },
		'-2': { 'label': t('sms_status_refunded'), 'class': 'bg-warning' },
	}

	async function searchWithFilter(customFilterData = filterData) {
		var filterDataCopy = { ...customFilterData }
		var filterUrl = "/sms-messages"
		var urlParams = ""

		if (filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
		if (filterDataCopy.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date
		if (filterDataCopy.status !== '' && filterDataCopy.status !== null && filterDataCopy.status !== undefined)
			urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		if (`/sms-messages${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
			setDropdownIsOpen(false)
		}
	}

	function handlePaginate(page) {
		const nextFilterData = { ...filterData, page }
		paginate(page)
		searchWithFilter(nextFilterData)
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const balance = data.balance || {}
	const summary = data.summary || {}

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('sms_messages')} [{data.total || 0}]
				</h4>
			</div>

			{/* Остаток — первое, что спрашивают: «на сколько ещё хватит».
				У чужого провайдера баланса и стоимости нет: клиент платит оператору
				напрямую, и наш баланс точки к его SMS отношения не имеет. */}
			<div className="row mb-3">
				{data.is_own_provider &&
					<div className="col-md-3">
						<div className="card h-100">
							<div className="card-body">
								<div className="text-muted">{t('balance')}</div>
								<div className="fw-600" style={{ 'fontSize': '1.2rem' }}>
									{formatMoney(balance.balance || 0)} {t('currency_soum')}
								</div>
								{balance.messages_left !== null && balance.messages_left !== undefined &&
									<div className="text-muted" style={{ 'fontSize': '.8rem' }}>
										≈ {formatMoney(balance.messages_left)} SMS · {balance.price} {t('currency_soum')}/SMS
									</div>
								}
							</div>
						</div>
					</div>
				}
				<div className="col-md-3">
					<div className="card h-100">
						<div className="card-body">
							<div className="text-muted">{t('sms_status_sent')}</div>
							<div className="fw-600" style={{ 'fontSize': '1.2rem' }}>{formatMoney(summary.sent || 0)}</div>
						</div>
					</div>
				</div>
				<div className="col-md-3">
					<div className="card h-100">
						<div className="card-body">
							<div className="text-muted">{t('sms_status_failed')}</div>
							<div className="fw-600" style={{ 'fontSize': '1.2rem' }}>{formatMoney(summary.failed || 0)}</div>
						</div>
					</div>
				</div>
				{data.is_own_provider &&
					<div className="col-md-3">
						<div className="card h-100">
							<div className="card-body">
								<div className="text-muted">{t('sms_spent')}</div>
								<div className="fw-600" style={{ 'fontSize': '1.2rem' }}>
									{formatMoney(summary.amount || 0)} {t('currency_soum')}
								</div>
							</div>
						</div>
					</div>
				}
			</div>

			<div className="card">
				<div className="card-body">

					<div className="d-flex mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={(search) => applySearch(search, searchWithFilter)}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={() => setDropdownIsOpen(!dropdownIsOpen)} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('period')}</label>
												<PeriodPicker
													withTime={false}
													startDate={filterData.start_date}
													endDate={filterData.end_date}
													onChange={(period) => patchFilterData(period)}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('status')}</label>
												<select className="form-select"
													value={filterData.status}
													onChange={(e) => patchFilterData({ 'status': e.target.value })}>
													<option value="">{t('all')}</option>
													<option value="1">{t('sms_status_sent')}</option>
													<option value="-1">{t('sms_status_failed')}</option>
													<option value="-2">{t('sms_status_refunded')}</option>
												</select>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => applyFilters(searchWithFilter)}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(appliedFilterData.start_date || appliedFilterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{appliedFilterData.start_date && <span>{formatDate(appliedFilterData.start_date)}</span>}
										{(appliedFilterData.start_date && appliedFilterData.end_date) && <span>|</span>}
										{appliedFilterData.end_date && <span>{formatDate(appliedFilterData.end_date)}</span>}
									</span>
								}
								{appliedFilterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{appliedFilterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={() => resetFilters({ ...initialFilterData }, searchWithFilter)}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '13%' }} className="text-center">{t('date')}</th>
									<th style={{ 'width': '12%' }}>{t('phone')}</th>
									<th style={{ 'width': '15%' }}>{t('event')}</th>
									<th style={{ 'width': '30%' }}>{t('text')}</th>
									<th style={{ 'width': '10%' }} className="text-center">SMS</th>
									{/* Сумма есть только у своего провайдера: у чужого мы её не знаем */}
									{data.is_own_provider &&
										<th style={{ 'width': '10%' }} className="text-end">{t('sum')}</th>
									}
									<th style={{ 'width': '10%' }} className="text-center">{t('status')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{item.row_number}</td>
										<td className="text-center text-nowrap">
											{formatDate(item.created_at, 'dd.MM.yy HH:mm')}
										</td>
										<td className="text-nowrap">{item.phone}</td>
										<td>
											<div style={{ 'fontSize': '.82rem' }}>{t(eventKey(item.event_code)) || item.event_code}</div>
											{item.cheque_id &&
												<div className="text-muted" style={{ 'fontSize': '.75rem' }}>#{item.cheque_id}</div>
											}
										</td>
										<td>
											<div style={{ 'fontSize': '.82rem' }}>{item.message}</div>
											{item.error &&
												<div className="text-danger" style={{ 'fontSize': '.75rem' }}>{item.error}</div>
											}
										</td>
										<td className="text-center">{item.segments}</td>
										{data.is_own_provider &&
											<td className="text-end text-nowrap">{formatMoney(item.amount)}</td>
										}
										<td className="text-center">
											<span className={'badge ' + (statuses[String(item.status)]?.class || 'bg-secondary')}>
												{statuses[String(item.status)]?.label || item.status}
											</span>
										</td>
									</tr>
								))}
								{(!data?.data || data.data.length === 0) &&
									<tr>
										<td colSpan={data.is_own_provider ? 8 : 7} className="text-center text-muted">{t('list_empty')}</td>
									</tr>
								}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={handlePaginate}>
						</FilterPagination>
					}
				</div>
			</div>
		</>
	)
}

// Коды событий доставки переведены в матрице настроек — переиспользуем те же ключи
function eventKey(eventCode) {
	const map = {
		'delivery.client.created': 'notif_client_created',
		'delivery.client.confirmed': 'notif_client_confirmed',
		'delivery.client.ready': 'notif_client_ready',
		'delivery.client.on_way': 'notif_client_on_way',
		'delivery.client.delivered': 'notif_client_delivered',
		'delivery.client.cancelled': 'notif_client_cancelled',
		'client.auth.code': 'sms_event_auth_code',
		'user.password.reset': 'sms_event_password_reset',
		'sms.manual': 'sms_event_manual',
		'sms.template': 'sms_event_manual',
		'sms.broadcast': 'sms_event_broadcast',
		'sms.rfm': 'sms_event_broadcast',
		'promo.code': 'sms_event_promo',
	}
	return map[eventCode] || eventCode
}

export default Index
